"use strict"
exports.__esModule = true;
exports.GlassWhiskeyIconConfig = {
  name: 'GlassWhiskeyIcon',
  height: 512,
  width: 512,
  svgPath: 'M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z',
  yOffset: 0,
  xOffset: 0,
};
exports.GlassWhiskeyIcon = require('../createIcon').createIcon(exports.GlassWhiskeyIconConfig);
exports["default"] = exports.GlassWhiskeyIcon;